<div class="navbar-item-search-container p-2">
  <div class="search-type">
    <ng-select
      [translationEditableModalDirective]="searchTypeKeys"
      [items]="searchTypes"
      [multiple]="false"
      [closeOnSelect]="true"
      class="is-small mr-2"
      bindLabel="label"
      bindValue="id"
      style="width: 170px"
      (change)="handleSearchTypeChange($event?.id)"
      appendTo=".search-type"
      [ngModel]="searchType"
    >
    </ng-select>
  </div>
  <input
    (change)="handleSearchKeywordChange($event?.target?.value)"
    class="input is-small"
    style="width: 190px"
    [value]="searchKeyword"
  />
  <button (click)="goToSearch()" class="navbar-item-search-btn ml-2">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="20px"
      fill="currentColor"
    >
      <path
        d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
      />
    </svg>
  </button>
</div>
